export default __webpack_public_path__ + "header_small.c0459eed.mp4";